import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  get: function (upc, distributionId = 'null') {
    return axios.get(`${window.apiURL}api/upc/${upc}/${distributionId}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/upc.js